import { Suspense } from "react";
import "./App.scss";
import { BrowserRouter as Router } from "react-router-dom";
// import { BrowserRouter as Router } from "react-router-dom";
import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import zhCN from "antd/locale/zh_CN";
import "dayjs/locale/zh-cn";
import WabaCaptchaRouter from "./router/wabaCaptchaRouter";

function App() {
  return (
    <Router>
      <Suspense>
        <ConfigProvider
          locale={localStorage.getItem("local") === "zh-cn" ? zhCN : enUS}
          theme={{
            token: {
              // fontFamily: "PingFang SC",
            },
          }}
        >
          <WabaCaptchaRouter />
          {/* </I18nextProvider> */}
        </ConfigProvider>
      </Suspense>
    </Router>
  );
}

export default App;
